import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../../assets/Richmond Castle hero.jpg";
import img2 from "../../assets/Richmond castle Kalutara.jpg";

function RichmondCastle() {

    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                <img
                    src={aboutHero}
                    alt="Richmond Castle"
                    className="absolute inset-0 w-full h-full object-fixed"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1 data-aos="fade-up" className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3">
                        Richmond Castle
                    </h1>
                </div>
            </section>

            {/* ================= ABOUT SECTION ================= */}
            <section className="relative w-full py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4">

                    {/* Image */}
                    <div
                        data-aos="zoom-in"
                        className="w-full overflow-hidden rounded-xl shadow-lg"
                    >
                        <img
                            src={img2}
                            alt="Kalutara Bodhiya"
                            className="w-full h-[500px] object-fixed"
                        />
                    </div>

                    {/* Content Card */}
                    <div
                        data-aos="fade-up"
                        className="relative -mt-24 mx-auto max-w-4xl bg-white border border-[#c97b3a] p-8 md:p-12 shadow-xl"
                    >
                        <h2 className="text-3xl font-bold text-center mb-6">
                            Richmond Castle
                        </h2>

                        <p className="text-gray-700 leading-relaxed text-justify mb-4">
                            Richmond Castle is one of Sri Lanka’s most remarkable colonial-era mansions, located on the banks of the Kalu Ganga near Kalutara. Built in the early 20th century, this grand Edwardian-style residence reflects the architectural elegance and refined taste of Sri Lanka’s elite during the British colonial period.
                        </p>

                        <p className="text-gray-700 leading-relaxed text-justify mb-4">
                            The castle features over 90 rooms, ornate balconies, stained-glass windows, and finely detailed woodwork, all set within beautifully landscaped gardens. Its design combines European architectural elements with adaptations suited to the tropical climate, including wide verandas and natural ventilation.
                        </p>

                        <p className="text-gray-700 leading-relaxed text-justify">
                            Surrounded by lush greenery and overlooking the river, Richmond Castle offers visitors a glimpse into Sri Lanka’s colonial history and aristocratic lifestyle. Today, it stands as a protected heritage site, admired for its timeless beauty, historical significance, and tranquil setting.
                        </p>
                    </div>
                </div>
            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94705108633?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20Cabana."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>

        </div>
    );
}

export default RichmondCastle;